import VueCookies from 'vue-cookies'
import { getEnv, isLocalIp } from '@/utils/env'
import { routeEventFix } from '@/config/routePrefix'
import { getLocation } from './ssrCompatible'
import { isInCoinsApp } from './utils'
import { countryOfCookiePopupStatus } from '@/config/country'
import { isUserExpOptiClosed } from '@/utils/native'
import { getDomain } from '@/utils/utils'

const isInApp = isInCoinsApp()
let appUserExpOptiClosed = isUserExpOptiClosed()
const domain = getDomain()

// cookie的状态ID
export const COOKIE_TYPE = {
  ESSENTIAL: 0, // 必要
  FUNCTIONAL: 1, // 功能性
  ADVERTISING: 2, // 广告
  ANALYTICAL: 3, // 性能
}

// !非必要cookie 默认会删除、只有同意才能加载
// ! 谨记、删除cookie的原理是通过 document.cookie 进行删除、要检查httpOnly是否勾选
const UnnecessaryCookie = [
  {
    form: COOKIE_TYPE.ANALYTICAL,
    cookieList: [
      {
        type: 'regular',
        value: /^_g[ai]*/i,
      },
    ],
  },
  {
    form: COOKIE_TYPE.ADVERTISING,
    cookieList: [
      {
        type: 'string',
        value: ['_gaexp', '_fbp'],
      },
    ],
  },
]
// 180day
export const cookieExpiresTime = 30 * 24 * 60 * 60 * 1000

// cookie定义的状态
export const cookieArrs = ['all', 'RejectAll', 'Preferences']

// 是否为本地环境
export const isLocalhost = (() => {
  const curHost = getLocation().host
  return curHost.indexOf('localhost') > -1 || isLocalIp()
})()

// 动态设置对象到cookie列表中
export function setCookieState(data = null) {
  if (!data) return
  // cookie无法设置除当前域名或者其父域名之外的其他domain
  // < https://segmentfault.com/a/1190000010419598 >
  if (isLocalhost) {
    VueCookies.set('cookie_state', data, '6m')
  } else {
    VueCookies.set('cookie_state', data, '6m', null, domain)
  }
}

// 动态获取cookie
export function getCookieState(key = 'cookie_state') {
  const result = VueCookies.get(key) || null
  return result
}

// 动态删除cookie
export function removeCookieState(key = 'cookie_state') {
  if (isLocalhost) {
    VueCookies.remove(key)
  } else {
    VueCookies.remove(key, null, domain)
  }
}

/**
 * @description: 动态加载\删除\等方法集合于一个公共的方法
 * @param {string} type： all：全部同意； RejectAll：全部拒绝；Preferences：部分同意
 * @param {Array} part: 用户同意的cookie类型、目前支持 埋点&& 广告营销两种
 * @return {null}
 */

export async function dynamicLoadingSDK() {
  const { type = '', part = [] } = getCookieState() || {}

  // 默认未开放的国家 不做处理
  const isOpen = initCuntryCookieState()

  // app内
  if (isInApp) {
    if (!isOpen) {
      // cookie政策未开放
      // loadTagJs()
      loadAnalyticsJs()
      return
    }
    appUserExpOptiClosed = isUserExpOptiClosed()
    // cookie政策开放：全部同意/全部拒绝
    if (appUserExpOptiClosed === true) {
      // 关闭用户体验改进
      removeExternalSDK()
      removeExternalCookies()
    } else {
      // 打开用户体验改进/老版本app
      // loadTagJs()
      loadAnalyticsJs()
    }
    return
  }

  if (!isOpen || type === 'all') {
    // loadTagJs()
    loadAnalyticsJs()
    return
  }

  // 本地状态不存在、视为第一次默认加载进入 || 全部拒绝
  if (type === '' || type === 'RejectAll') {
    removeExternalSDK()
    removeExternalCookies()

    const massage =
      type === 'RejectAll'
        ? `'警告：由于用户全部拒绝cookie注入、无法获取埋点信息'`
        : `'警告：初次加载、本地相关SDK、cookie全部删除`
    window && window.console.warn(massage)
    return
  }

  // 部分同意
  if (type === 'Preferences') {
    removeExternalCookies()
    partialAgreement(part)
  }

  // 加载 jsTag SDK
  // function loadTagJs() {
  //   const jsTag = document.createElement('script')
  //   jsTag.id = '__jsTag__id'
  //   jsTag.setAttribute('src', process.env.VUE_APP_GA_JS_URL)
  //   jsTag.addEventListener('load', function () {
  //     window.load_gatg = true
  //     tarckAllEvent()
  //   })
  //   document.querySelector('head').appendChild(jsTag)
  // }

  // 加载analyticsv4 版本的SDK
  function loadAnalyticsJs() {
    const jsTag = document.createElement('script')
    jsTag.id = '__analytics__id'
    jsTag.async = true
    jsTag.setAttribute('src', `/firebase/firebase-analytics.js`)
    jsTag.addEventListener('load', function () {
      firebase && firebase.analytics && firebase.analytics()
      window.load_analytics = true
      tarckAllEvent()
    })
    document.querySelector('body').appendChild(jsTag)
  }

  // 根据类型 移除外部的SDK
  function removeExternalSDK(type = 'all') {
    if (isInApp) {
      if (appUserExpOptiClosed === true) {
        type = 'all'
      } else {
        return
      }
    }
    const ohead = document.querySelector('head')
    const obody = document.querySelector('body')

    const jsTagId = ohead.querySelector('#__jsTag__id')
    const fbeventsId = ohead.querySelector('#__fbevents__id')
    const TiktokId = ohead.querySelector('#__tiktok__id')
    const analyticsId = obody.querySelector('#__analytics__id')

    // 默认全部删除
    if (type === 'all') {
      if (jsTagId) {
        ohead.removeChild(jsTagId)
      }
      if (analyticsId) {
        obody.removeChild(analyticsId)
      }
      if (fbeventsId) {
        ohead.removeChild(fbeventsId)
      }
      if (TiktokId) {
        ohead.removeChild(TiktokId)
      }
      window.gtag = null
    }

    // 移除性能相关的SDK
    if (type === 'analytical') {
      if (jsTagId) {
        ohead.removeChild(jsTagId)
      }
      if (analyticsId) {
        obody.removeChild(analyticsId)
      }
      if (TiktokId) {
        ohead.removeChild(TiktokId)
      }
      window.gtag = null
    }

    // 移除广告相关
    if (type === 'advertising') {
      if (fbeventsId) {
        ohead.removeChild(fbeventsId)
      }
    }
  }

  // 移除外部的SDK种植的cookies
  function removeExternalCookies() {
    if (isInApp) {
      if (appUserExpOptiClosed === true) {
        // app内且关闭用户体验改进
        unifiedRemove()
        return
      }
      return
    }

    const cookieState = getCookieState() || {}
    const { part = [] } = cookieState
    // 非必要的全部类型
    const cookieValue = Object.values(COOKIE_TYPE).slice(1)
    // 默认不存在缓存标识
    if (!Object.keys(cookieState).length) {
      unifiedRemove()
      return
    }

    // 全部拒绝
    if (!part.length) {
      unifiedRemove()
      return
    }

    // 获取关闭的cookie的类型
    const filterRes = cookieValue.filter((item) => part.indexOf(item) == -1)

    // 广告营销
    if (filterRes.includes(COOKIE_TYPE.ADVERTISING)) {
      unifiedRemove(COOKIE_TYPE.ADVERTISING)
    }
    // 数据分析
    if (filterRes.includes(COOKIE_TYPE.ANALYTICAL)) {
      unifiedRemove(COOKIE_TYPE.ANALYTICAL)
    }

    // 统一删除方法
    function unifiedRemove(type = 'all') {
      if (isInApp) {
        type = 'all'
      }

      const allCookies = VueCookies && VueCookies.keys()

      // 删除全部
      if (type === 'all') {
        const filterCookieList = UnnecessaryCookie.reduce(
          (accumulator, currentValue) => {
            accumulator = accumulator.concat(currentValue.cookieList)
            return accumulator
          },
          []
        )

        // type = string 进行全部删除
        filterCookieList
          .reduce((_accumulator, _currentValue) => {
            if (_currentValue.type === 'string') {
              _accumulator = _accumulator.concat(_currentValue.value)
            }
            return _accumulator
          }, [])
          .forEach((item) => {
            if (isLocalhost) {
              VueCookies.remove(item)
            } else {
              VueCookies.remove(item, null, domain)
            }
          })

        // type = regular 进行删除
        filterCookieList
          .reduce((_accumulator, _currentValue) => {
            if (_currentValue.type === 'regular') {
              _accumulator = _accumulator.concat(_currentValue.value)
            }
            return _accumulator
          }, [])
          .reduce((_accumulator, _currentValue) => {
            _accumulator = _accumulator.concat(
              allCookies.filter((item) => _currentValue.test(item))
            )
            return _accumulator
          }, [])
          .forEach((item) => {
            if (isLocalhost) {
              VueCookies.remove(item)
            } else {
              VueCookies.remove(item, null, domain)
            }
          })

        return
      }

      const { cookieList } = UnnecessaryCookie.find(
        (item) => item.form === type
      )

      for (let keys of cookieList) {
        if (keys.type === 'regular') {
          const filterList = allCookies.filter((item) => keys.value.test(item))

          if (filterList && filterList.length) {
            filterList.forEach((item) => {
              removeCookieState(item)
            })
          }
        }
        if (keys.type === 'string') {
          const filterList = allCookies.filter(
            (item) => keys.value.indexOf(item) > -1
          )

          if (filterList && filterList.length) {
            filterList.forEach((item) => {
              removeCookieState(item)
            })
          }
        }
      }
    }
  }

  // 部分同意cookie协议
  function partialAgreement(parts) {
    const cookieTypes = Object.values(COOKIE_TYPE)
    const filterTypes = cookieTypes.filter((item) =>
      parts.find((_item) => _item === item)
    )

    if (filterTypes.length) {
      if (filterTypes.length === 1) {
        // 同意 性能
        if (filterTypes[0] === COOKIE_TYPE.ANALYTICAL) {
          // loadTagJs()
          loadAnalyticsJs()
          removeExternalSDK('advertising')
        }

        if (filterTypes[0] === COOKIE_TYPE.ADVERTISING) {
          removeExternalSDK('analytical')
        }

        removeExternalCookies()
      }
      if (filterTypes.length === 2) {
        // loadTagJs()
        loadAnalyticsJs()
      }
    } else {
      removeExternalSDK()
      removeExternalCookies()
    }
  }
}

/**
 * @description: cookie二期【根据国家配置展示cookie功能表】
 * @param {string} name 国家名称缩写、
 * @param {boolean} isOpen 是否开启
 */
export function initCuntryCookieState() {
  // app隐私：在app内所有国家都默认开启cookie隐私，按照隐私政策进行打点，但不弹出cookie弹窗
  if (isInApp) {
    return true
  }

  const cuntryCookie = countryOfCookiePopupStatus()

  const _location = window.location
  const country = 'id' // 默认国家
  let result = null

  // 获取开放国家
  const getOpenCuntry = () => {
    let res = null
    const fix = routeEventFix('/')
    if (fix === '/') {
      res = cuntryCookie.find((item) => country === item.name) || null
    } else {
      res = cuntryCookie.find((item) => fix.indexOf(item.name) !== -1) || null
    }
    return res
  }

  if (_location.href.indexOf('www') !== -1 || getEnv() !== 'online') {
    result = getOpenCuntry()
  } else {
    result =
      cuntryCookie.find((item) => _location.host.indexOf(item.name) !== -1) ||
      null
  }
  return result ? result.isOpen : false
}

/**
 * @description: 不是默认加载SDK、针对各别页面单独进行动态加载处理
 * @param {Array[object]} loadCallBack [{form:"RejectAll",callback:'xxxx'}]
 * @return {Function} callback 是否加载的回调函数
 */

export function notInitLoadSDK(loadCallBack = []) {
  const cookieState = getCookieState() || {}
  const { type: _type = '', part = [] } = cookieState
  let type = _type

  if (!loadCallBack.length) {
    window.console.warn('警告：传递的参数为空、请检查是否执行')
    return
  }

  // 默认未开放的国家 不做处理
  const isOpen = initCuntryCookieState()
  if (!isOpen) {
    for (const item of loadCallBack) {
      const { callback } = item
      callback && callback()
    }

    return new Promise((resolve) => {
      const sdkIdlist = loadCallBack
        .map((item) => `#${item.id}`)
        .some((item) => !!document.querySelector(item))
      setTimeout(() => {
        resolve(sdkIdlist)
      }, 1000)
    })
  }

  if (isInApp) {
    appUserExpOptiClosed = isUserExpOptiClosed()
    // app内
    if (appUserExpOptiClosed === true) {
      // 关闭体验改进，代表全部拒绝
      type = cookieArrs[1]
    } else {
      // 打开体验改进/老版本app，代表全部同意
      type = cookieArrs[0]
    }
  } else {
    // 非app，保持原来逻辑
    type = _type
  }

  for (const item of loadCallBack) {
    const { form, callback } = item
    if (!form || !callback) {
      window.console.error('报错：传递参数有误')
      return
    }

    // 【全部同意】
    if (type === cookieArrs[0]) {
      callback && callback()
    }

    // 【部分同意】且广告\营销 状态打开
    if (
      form === COOKIE_TYPE.ADVERTISING &&
      type === cookieArrs[2] &&
      part.length &&
      part.includes(COOKIE_TYPE.ADVERTISING)
    ) {
      callback && callback()
    }

    // 【部分同意】且数据分析 状态打开
    if (
      form === COOKIE_TYPE.ANALYTICAL &&
      type === cookieArrs[2] &&
      part.length &&
      part.includes(COOKIE_TYPE.ANALYTICAL)
    ) {
      callback && callback()
    }

    // 【部分同意】且功能相关 状态打开
    if (
      form === COOKIE_TYPE.FUNCTIONAL &&
      type === cookieArrs[2] &&
      part.length &&
      part.includes(COOKIE_TYPE.FUNCTIONAL)
    ) {
      callback && callback()
    }
  }

  return new Promise((resolve) => {
    const sdkIdlist = loadCallBack
      .map((item) => `#${item.id}`)
      .some((item) => !!document.querySelector(item))
    setTimeout(() => {
      resolve(sdkIdlist)
    }, 1000)
  })
}

/**
 * @description: 队列的形式、进行统一上报
 * @return {*}
 */

function tarckAllEvent() {
  if (
    window.load_analytics &&
    window.__trackQueue &&
    window.__trackQueue.length &&
    window.gtag &&
    typeof window.gtag === 'function'
  ) {
    window.gtag('js', new Date())
    window.gtag('config', process.env.VUE_APP_GA_TARGET_ID, {
      site_speed_sample_rate: 100,
    })
    window.__trackQueue.forEach(({ eventName, params }) => {
      window.gtag('event', eventName, params)
    })
  }
}
